import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
    SortableContext,
    arrayMove,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import SortableStopItem from "./SortableStopItem";

const SelectedStopsPanel = ({ stops = [], onChange, onRemove, onTimeChange }) => {
    const handleDragEnd = ({ active, over }) => {
        if (!over?.id || active.id === over.id) return;

        const oldIndex = stops.findIndex(
            (item) => Number(item.locid) === Number(active.id)
        );
        const newIndex = stops.findIndex(
            (item) => Number(item.locid) === Number(over.id)
        );

        if (oldIndex < 0 || newIndex < 0) return;

        onChange(arrayMove(stops, oldIndex, newIndex));
    };

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                borderRadius: 2.5,
                height: "100%",
                backgroundColor: "#fafafa",
            }}
        >
            <Typography variant="subtitle1" fontWeight="bold">
                Paradas seleccionadas ({stops.length})
            </Typography>

            <Typography variant="body2" color="text.secondary" mb={1.5}>
                Arrastra para ordenar la ruta. La primera parada será origen y la última
                destino.
            </Typography>

            {stops.length === 0 ? (
                <Box
                    sx={{
                        p: 3,
                        border: "1px dashed #cfd8dc",
                        borderRadius: 2,
                        textAlign: "center",
                        backgroundColor: "#fff",
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        Aún no hay paradas seleccionadas.
                    </Typography>
                </Box>
            ) : (
                <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                    <SortableContext
                        items={stops.map((stop) => stop.locid)}
                        strategy={verticalListSortingStrategy}
                    >
                        {stops.map((stop, index) => (
                            <SortableStopItem
                                key={stop.locid}
                                stop={stop}
                                index={index}
                                total={stops.length}
                                onRemove={onRemove}
                                onTimeChange={onTimeChange}
                            />
                        ))}
                    </SortableContext>
                </DndContext>
            )}
        </Paper>
    );
};

export default SelectedStopsPanel;